import type { Address } from "./types";

const ETH_ADDRESS_RE = /^0x[0-9a-fA-F]{40}$/;

/**
 * Check if a string is a valid Ethereum address (0x + 40 hex chars).
 * Returns a type guard narrowing to `Address`.
 */
export function isValidAddress(addr: string): addr is Address {
  return ETH_ADDRESS_RE.test(addr);
}

/**
 * Normalize an Ethereum address to lowercase.
 * @throws if the address is not valid
 */
export function normalizeAddress(addr: string): Address {
  if (!isValidAddress(addr)) {
    throw new Error(`Invalid Ethereum address: ${addr}`);
  }
  return addr.toLowerCase() as Address;
}

/**
 * Truncate an address for display, e.g. "0x1234…abcd".
 */
export function truncateAddress(
  addr: string,
  prefixLen = 6,
  suffixLen = 4,
): string {
  if (addr.length <= prefixLen + suffixLen) return addr;
  return `${addr.slice(0, prefixLen)}…${addr.slice(-suffixLen)}`;
}

/**
 * Sort two token addresses into canonical order (lower address first).
 * Required for Uniswap V3/V4 where token0 < token1.
 */
export function sortTokens(a: Address, b: Address): [Address, Address] {
  return a.toLowerCase() < b.toLowerCase() ? [a, b] : [b, a];
}
